<template>
    <div class="container">
        <div class="title">
            <div class="title-text">
                <span v-if="viewdisabled">sku查看</span>
                <span v-else>sku编辑</span>
            </div>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-width="130px">
            <el-form-item label="商品名称" prop="name">
                <el-input v-model="form.name" required="true"
                :clearable="true" maxlength="50" show-word-limit
                :disabled="viewdisabled"></el-input>
            </el-form-item>
            <el-form-item label="商品副标题">
                <el-input v-model="form.subTitle" :clearable="true"
                 maxlength="120" show-word-limit :disabled="viewdisabled">
                </el-input>
            </el-form-item>
            <el-form-item label="头图列表" prop="headPics">
                <el-upload
                    v-model="form.headPics"
                    action="/platform/interface/uploadimg"
                    list-type="picture-card"
                    name="imgFile"
                    :limit="9"
                    :disabled="viewdisabled"
                    :file-list="fileList"
                    :before-upload="beforeAvatarUpload"
                    :on-preview="handlePreview"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                    :on-exceed="handleExceed"
                    :on-error="handleError">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <div class="img-upload-tip">只能上传 jpg/jpeg/bmp/png 文件，且不超过10mb</div>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
			<el-form-item label="商品详情">
                <!-- <quill-editor 
                    v-model="form.detailInfo"
                    ref="myQuillEditor" 
                    :options="editorOption"
                    @change="onEditorChange($event)">
                </quill-editor> -->
                <quill-editor 
                    v-model="content"
                    ref="myQuillEditor" 
                    :options="editorOption"
                    @change="onEditorChange($event)">
                </quill-editor>
                <el-upload
                    id="iviewUp"
                    v-show="false"
                    action="/platform/interface/uploadimg"
                    :before-upload="beforeAvatarUpload"
                    :show-file-list="false"
                    list-type="picture-card"
                    name="imgFile"
                    :on-success="handleSuccessQuill">
                </el-upload>
            </el-form-item>
            <el-form-item label="平台自定义属性">
                    <div v-for="(item, index) in form.platformProperty" class="standardLine" v-if="item.show">
                        <label class="el-form-item-value" v-if="item.show">{{item.propertyName}}</label><br/>
                        <el-tag v-for="tag in item.propertyValues" @click="item.propertyValue = tag" v-if="item.show"class="standardTag">{{tag}}</el-tag>
                        <el-input v-model="form.platformProperty[index].propertyValue" 
                        v-if="item.show"
                        placeholder="请输入内容" :disabled="viewdisabled"></el-input><br/>
                    </div>
                    
                </el-form-item>
                <el-form-item label="商家自定义属性">
                    <div v-for="(item, index) in form.merchantProperty">
                        <span class="delete" @click="delMerchantProperty(index)" v-if="!viewdisabled">&times</span>
                        <label class="el-form-item-value">属性名</label>
                        <el-input v-model="form.merchantProperty[index].propertyName" placeholder="请输入内容" :disabled="viewdisabled"></el-input>
                        <label class="el-form-item-value">属性值</label><!-- <input v-model="form.merchantProperty[index].propertyValue" > -->
                        <el-input v-model="form.merchantProperty[index].propertyValue" placeholder="请输入内容" :disabled="viewdisabled"></el-input>
                    </div>
                    <P class="addMerchantProperty" href="javascript:;" @click="addMerchantProperty" v-if="!viewdisabled">+新增商家自定义属性</P>
                </el-form-item>
                
                
                <el-form-item label="规格详情">
                    <div v-for="(item, index) in form.standardInfo" class="standardLine" v-if="item.show">
                        <label class="el-form-item-value" v-if="item.show">{{item.standardName}}</label><br/>
                        <el-tag v-for="tag in item.standardValues" @click="item.standardValue = tag" v-if="item.show" class="standardTag">{{tag}}</el-tag>
                        <el-input v-model="item.standardValue" v-if="item.show" placeholder="请输入内容" class="standardValue"  :disabled="viewdisabled"></el-input>
                        <br/>
                    </div>
                    
                </el-form-item>
                <el-form-item label="价格">
                    <div>
                        <label class="el-form-item-value price-left">市场价</label>
                        <el-input-number v-model="form.marketPriceValue" size="large" :precision="2" :max="10000000" :min="0" :step="0.1" :disabled="viewdisabled"></el-input-number>
                        <span class="el-form-item-value price-right">元</span>
                    </div>
                    <div class="salePriceValue-box">
                        <label class="el-form-item-value price-left"  style="margin-left:10px;"><span class="required">*</span>销售价</label>
                        <el-input-number v-model="form.salePriceValue" size="large" :precision="2"  :max="10000000" :min="0" :step="0.1" :disabled="viewdisabled"></el-input-number>
                        <span class="el-form-item-value price-right">元</span>
                        <p class="required salePrice-error" v-if="salePriceError">请输入销售价</p> <!--  -->
                    </div>
                </el-form-item>
                <el-form-item label="库存数量" prop="primaryStock">
                    <el-input-number class="primaryStock" v-model="form.primaryStock" :disabled="viewdisabled"  :min="0" label="描述文字" ></el-input-number>
                </el-form-item>
            <el-form-item>
                <div class="button-wrapper">
                    <el-button type="primary" @click="onSubmit" v-if="!viewdisabled">提交</el-button>
                    <el-button @click="backList">取消</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import Quill from 'quill';
    let Align = Quill.import('attributors/style/align');
    Quill.register(Align, true);
    let toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        ['image'],
        [{'header': 1}, {'header': 2}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{'direction': 'rtl'}],
        [{'size': ['small', false, 'large', 'huge']}],
        [{'header': [1, 2, 3, 4, 5, 6, false]}],
        [{'color': []}, {'background': []}],
        [{'font': []}],
        [{'align': []}],
        ['clean']
    ];
import {
    quillEditor
}  from 'vue-quill-editor';
export default {
    components: {
        quillEditor
    },
    data() {
        
        return {
            dialogVisible: false,
            dialogImageUrl: '',
            viewdisabled: false,
            fileList: [],
            // [   {   name: 'food.jpeg',
            //         url: 'https://100'
            //     }, 
            //     {   name: 'food.jpeg',
            //         url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
            //     }, 
            //     {   name: 'food2.jpeg', 
            //         url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bceuality/100'}],
            form: {
                name: '',
                subTitle: '',
                detailInfo: '',
                headPics: [],
                standardInfo: [],
                marketPriceValue: 0,
                skuId: '',
                salePriceValue: 0,
                platformProperty: [],
                merchantProperty:[],
                primaryStock: 0
            },
            editor: null,   // 富文本编辑器对象
            content: '', // 富文本编辑器默认内容
            editorOption: {
                placeholder: '',
                // or 'bubble'
                theme: 'snow',
                modules: {
                    toolbar: {
                        // 工具栏
                        container: toolbarOptions,
                        handlers: {
                            image(value) {
                                if (value) {
                                    document.querySelector('#iviewUp input').click();
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            },
            spuId: '',
            // 校验
            rules: {
                name: [
                    {required: true, message: '请输入商品名称', trigger: 'blur'}
                ],
                headPics: [
                    {required: true, message: '请至少上传一张头图列表', trigger: 'blur'}
                ],
                primaryStock: [
                    {required: true, message: '请输入库存数量'}
                ]
            },
            salePriceError: false
        };
    },
    mounted() {
        this.spuId = this.$route.query.spuId;
        this.getDetail();
        // this.editor = this.$refs.myQuillEditor.quill;
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm => {
            window.scrollTo(0, 0);
        });
    },
    beforeDestroy() {
        this.editor = null;
        delete this.editor;
    },
    methods: {
        // 图片上传前的格式+大小校验
        beforeAvatarUpload(file) {
            console.log(file, 98989);
            const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp');
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传图片只能是jpg/jpeg/bmp/png格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            return isJPG && isLt2M;
        },
        delMerchantProperty(index) {
            this.form.merchantProperty.splice(index, 1);
        },
        addMerchantProperty() {
            if (this.form.merchantProperty.length >= 5) {
                return;
            }
            this.form.merchantProperty.push(
                {
                    propertyName: '',
                    propertyValue: ''
                }
            );
        },
        getDetail() {
            if (this.$route.query.view == 1) {
                this.viewdisabled = true;
            }
            this.$api.skuinfo({
                skuId: this.$route.query.skuId
            }).then(res => {
                if (res.code === 0) {
                    // 接口成功做的操作
                    this.form = res.data || this.form;
                    // 获取富文本编辑器列表
                    this.content = this.form.detailInfo;
                    this.spuId = this.form.spuId;
                    this.form.standardInfo.forEach((item, i) => {
                        item.show = item.standardValue && this.viewdisabled || !this.viewdisabled;
                        this.form.standardInfo[i].standardValues = item.standardValues.split('|');
                    });
                    this.form.platformProperty.forEach((item, i) => {
                        item.show = item.propertyValue && this.viewdisabled || !this.viewdisabled;
                        this.form.platformProperty[i].propertyValues = item.propertyValues.split('|');
                    });
                    this.form.headPics.forEach((item, index) => {
                        this.fileList.push({
                            url: item
                        });
                    });
                }
                else {
                    this.$message.error(res.msg);
                }
                
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
		},
        onSubmit() {
            for (let p in this.form) {
                if (typeof this.form[p] === 'string') {
                    this.form[p] = this.form[p].trim();
                }
            }
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false;
                }
            });
            let param = Object.assign({}, this.form);
            param.standardInfo = JSON.stringify(param.standardInfo);
            param.platformProperty = JSON.stringify(param.platformProperty);
            param.merchantProperty = JSON.stringify(param.merchantProperty);
            param.headPics = [];
            param.spuId = this.spuId || this.$route.query.spuId;
            this.fileList.forEach((item, index) => {
                param.headPics.push(item.url);
            });
            param.skuId = this.form.skuId || this.$route.query.skuId;
            param.headPics = JSON.stringify(param.headPics);
            if (param.salePriceValue === 0) {
                this.salePriceError = true;
                setTimeout(() => {
                    this.salePriceError = false;
                }, 2000);
                return;
            }
            this.$api.merchantSkuUpdate(param).then(res => {
                // 接口成功做的操作
                
                if (res.code === 0) {
                    this.$message({
                        message: '恭喜你，提交成功',
                        type: 'success'
                    });
                    this.backList();
                }
                else {
                    this.$message.error(res.msg);
                }
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        backList() {
            this.$router.push({
                path: '/merchantManagement/list',
                query: {
                    spuId: this.spuId || this.$route.query.spuId
                }
            });
        },
        handleRemove(file, fileList) {
            this.fileList = this.fileList.filter(item => {
                return item.url !== file.url;
            });
            this.fileList.forEach((item, index) => {
                if (item.url === file.url) {
                    delete this.fileList[index];
                }
            });
            console.log(this.fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
         // 富文本内容发生改变时
        onEditorChange(event) {
            this.form.detailInfo = event.html;
        },
        handleSuccessQuill(res) {
            console.log(this.$refs.myQuillEditor.quill.getSelection().index, 1234567)
            // 获取富文本组件实例
            let quill = this.$refs.myQuillEditor.quill;
            let code;
            if (!res.hasOwnProperty('code')) {
                code = res.errno;
            } else {
                code = res.code;
            }
            // 如果上传成功
            if (code === 0) {
                // 获取光标所在位置
                let length = this.$refs.myQuillEditor.quill.selection.savedRange.index;
                // 插入图片  res.info为服务器返回的图片地址
                quill.insertEmbed(length, 'image', res.data.imgUrl);
                // 调整光标到最后
                quill.setSelection(length + 1);
            } else {
                this.$message({
                    message: '图片插入失败',
                    type: 'warning'
                });
            }
        },
        // 预览图片
        handlePreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
            console.log(file);
        },
        // 图片上传成功
        handleSuccess(res, file) {
            this.fileList.push({
                url: res.data.imgUrl
            });
            this.form.headPics.push(res.data.imgUrl);
        },
        // 超出上传限制数
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制上传9个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        // 图片上传报错
        handleError(err, file, fileList) {
            console.log(err, file, fileList, 123456789)
        }
    }
};
</script>
<style lang="less" scoped>
.container {
    .title {
        width: 100%;
        border: solid 1px #EBEEF5;
        color: #303133;
        font-size: 20px;
        padding: 20px 15px;
        border-radius: 4px;
        margin: 0 0 20px 0;
        .title-text {
            display: flex;
            align-items: center;
            .title-logo {
                width: 20px;
                margin-right: 12px;
            }
        }
    }
    .el-form {
        margin-top: 50px;
        width: 50%;
    }
    .el-form-item__content {
        margin-left: 0;
        text-align: center;
    }
    .button-wrapper {
        margin-top: 20px;
        text-align: center;
	}
	.standardLine {
		margin-bottom: 20px;
	}
	.standardName {
		display: inline-block;
		width: 50px;
	}
	.marketPriceValue {
		width: 60px;
		margin-right: 40px;
	}
    .addMerchantProperty {
        color:#007eff;
    }
    .delete {
        font-size: 26px;
        color: #bfb9b9;
        position: absolute;
        right: 2px;
    }
    .standardTag {
        margin-right: 20px;
    }
    .standardValue {
        display: inline;
    }
    .el-form-item-value {
		display: inline-block;
		color: #706969;
    }
    .primaryStock {
        margin-left: 47px;
    }
    .price-left {
        margin-right: 4px;
    }
    .price-right {
        margin-left: 4px;
    }
    .salePriceValue-box {
        margin-left: -20px;
        margin-top: 20px;
    }
    .required {
        color: #F56C6C;
        margin-right: 4px;
    }
    .salePrice-error {
        margin-left: 114px;
        margin-bottom: -20px;
    }
}
</style>